
























import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ProcessMetadata } from '@/context/calculation/model/ProcessMetadata';

@Component
export default class CalculationCard extends Vue {
  @Prop({ default: "" }) value!: ProcessMetadata;
  @Prop({ default: "" }) title!: string;
  getStatusColor(status: string) {
    console.log(status);
    switch (status) {
      case "IN_QUEUE":
        return "info";
      case "IN_PROGRESS":
        return "orange";
      case "PROCESSED":
        return "green";
      case "ERROR":
        return "red";
    }
  }
  getType(status: string) {
    console.log(status);
    switch (status) {
      case "IN_QUEUE":
        return "info";
      case "IN_PROGRESS":
        return "warning";
      case "PROCESSED":
        return "success";
      case "ERROR":
        return "error";
    }
  }
}
